import {Component, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {Step, StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ModeratRequestService} from "../services/request.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {VerbrauchsanalyseModeratForm} from "./verbrauchsanalyse.moderat.form";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {WpcheckStartComponent} from "../wpcheck/wpcheck.start.component";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {HeizcheckConstants} from "../../heizcheck/heizcheck.constants";

/**
 * Overwrite the Generic step component for the first section fo the moderat.
 *
 * @inheritDoc
 */
@Component({
  selector: 'app-step-verbrauchsanalyse',
  templateUrl: '../../step/step.component.html'
})
export class VerbrauchsanalyseStepComponent extends StepComponent implements OnInit{

  /**
   * (input) data of the user
   */
  anfrage: ModeratAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: VerbrauchsanalyseModeratForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix: string = "moderat";

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ModeratRequestService, protected elementService: ElementService,
              protected portalService: PortalService, protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new VerbrauchsanalyseModeratForm(this.energyMapService);
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);
    this.formConfig.anfrage = this.anfrage;

    // update the previous step
    this.onStepUpdate();

    // show navigation element back to the wpcheck
    if(this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.stepService.setNavigationPreElement(
        new StepNavigationElement('moderat.nav.wpcheck.', true, WpcheckStartComponent.wpcheckUrl.replace('{{portalId}}', this.portalService.currentPortalId))
      );
    }

    // init error placeholder
    this.initErrorPlaceholder();
  }

  /**
   * @inheritDoc
   * @param data
   */
  saveData(data:{[key: string]: any}) {
    // merge the data with the existing data
    this.anfrage.verbrauchsanalyseInput = {...this.anfrage.verbrauchsanalyseInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * Return the next step from a step list
   * @param stepList
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if(this.anfrage?.verbrauchsanalyseInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.verbrauchsanalyseInput);
      // save the data again. In some case some fields are autoupdatetd
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onSubmit(): void {
    /* some inputs end the advisor */
    if(this.isAdvisorEnd()) {
      // save data
      this.saveData(this.formConfig.getData());

      // navigate to end page
      this.router.navigateByUrl(this.portalService.currentPortalId + "/moderat/verbrauchsanalyse/ausstieg", {state: {lastStep: this.router.url}});
      return;
    }

    super.onSubmit();
  }

  /**
   * In some cases the advisor has to stop because we cannot offer any advice for this user/building
   * Hint: new cases have to be added also to VerbrauchsanalyseAusstiegComponent
   */
  isAdvisorEnd(): boolean {
    // not central heating
    if(this.form.get("heizungstyp") && (this.form.get("heizungstyp")?.value === "dezentral" || this.form.get("heizungstyp")?.value === "dezentral2")) {
      return true;
    }

    // mieter
    if(this.form.get("nutzungstyp") && this.form.get("nutzungstyp")?.value === "mieter") {
      return true;
    }

    // denkmalschuz
    if(this.form.get("gebaeude_denkmalschutz") && this.form.get("gebaeude_denkmalschutz")?.value === "ja") {
      return true;
    }

    return false;
  }

  /**
   * inits placeholder for error messages
   */
  initErrorPlaceholder(): void {
    if(this.form?.controls['anzahl_wohneinheiten']) {
      this.subscriptions.push(this.form?.controls['anzahl_wohneinheiten']?.valueChanges?.subscribe((value) => {
        const averageSize = Math.round(this.anfrage.verbrauchsanalyseInput.gebaeude_flaeche / value);
        if (averageSize < HeizcheckConstants.APARTMENT_SIZE_MIN || averageSize > HeizcheckConstants.APARTMENT_SIZE_MAX) {
          this.stepErrorPlaceholder = {
            apartmentSize: averageSize,
            portalId: this.portalService?.currentPortalId
          }
        }
      }));
    }
  }

}
